import { colorsPalettes } from "@similarweb/styles";

export const LOYALTY_CATEGORIES_COLORS = {
    "0": {
        backgroundColor: colorsPalettes.midnight["400"],
        color: colorsPalettes.carbon["0"],
    },
    "1": {
        backgroundColor: colorsPalettes.blue["500"],
        color: colorsPalettes.carbon["0"],
    },
    "2": {
        backgroundColor: colorsPalettes.blue["400"],
        color: colorsPalettes.carbon["0"],
    },
    "3": {
        backgroundColor: colorsPalettes.blue["300"],
        color: colorsPalettes.carbon["0"],
    },
    "4": {
        backgroundColor: colorsPalettes.sky["300"],
        color: colorsPalettes.black["0"],
    },
    "5+": {
        backgroundColor: colorsPalettes.sky["200"],
        color: colorsPalettes.black["0"],
    },
};
